function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useQuery } from "@apollo/client";
import moment from "moment-timezone";
import React from "react";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";
import Row from "react-bootstrap/Row";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Table from "react-bootstrap/Table";
import { Chart } from "react-google-charts";
import isSameDay from "date-fns/isSameDay";
import classNames from "classnames";
import { Helmet } from "react-helmet";
import { FilterContext, UserContext, TrackingContext } from "../index";
import UserSidemenu from "../SideMenu/UserSidemenu";
import { chartSelectedColor } from "./../Dashboard/TopAppsAndWebsites";
import "./PersonalStatistics.css";
import { PERSONAL_STAT_DATA_QUERY, PERSONAL_TASK_DATA_QUERY } from "./query";
import { HiQuestionMarkCircle } from "react-icons/hi";
var _require = require("../utils"),
  convertSecToHoursAndMinutesAndSecWithTextShortForm = _require.convertSecToHoursAndMinutesAndSecWithTextShortForm,
  convertSecToHours = _require.convertSecToHours,
  randomColor = _require.randomColor,
  colors = _require.colors,
  hexToRgb = _require.hexToRgb,
  convertSecToHoursAndMinutesWithTextShortForm = _require.convertSecToHoursAndMinutesWithTextShortForm,
  lightAndDarkColors = _require.lightAndDarkColors;
import Loader from "./../Loader/Loader";
import { BillingDueExtendedMsg, BillingBankTrasferPlanEndBeforeMsg } from "./../Billing/Billing";
import { WarningCardOrgTimezone, WarningCardMaintenance, NewProductCard } from "./../Dashboard/Dashboard";
import { arrayToStringOutput } from "./../SideMenu/Header";
import { FaRegCalendar, FaShoppingBag } from "react-icons/fa";
var PersonalStatistics = function PersonalStatistics(props) {
  var _match$params, _personalData$persona6, _personalData$persona7, _personalData$persona8, _personalData$persona9, _personalData$persona10, _personalData$persona11, _personalData$persona12, _personalData$persona13, _personalData$persona14, _personalData$persona15;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    organisationId = _React$useContext2.organisationId,
    teamId = _React$useContext2.teamId,
    startDate = _React$useContext2.startDate,
    endDate = _React$useContext2.endDate,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationBilling = _React$useContext2.organisationBilling,
    from = _React$useContext2.from,
    role = _React$useContext2.role,
    timezoneFilter = _React$useContext2.timezoneFilter;
  var tracking = React.useContext(TrackingContext);
  var _ref = tracking || {},
    task = _ref.task;
  var match = props.match,
    Link = props.linkComponent,
    linkProps = props.linkProps;
  var url = (match === null || match === void 0 ? void 0 : (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.url) || props.url;
  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings.organisationTimezone);

  //console.log("from",from)

  // React.useEffect(() => {
  //   if (from == "web" && role == "Member" && organisationSettings?.allowMemberToAccessTimesheet) {
  //     props?.history.push("/timesheet");
  //   }
  //   if (from == "web" && role == "Member" && organisationSettings?.manualTimeFeature) {
  //     props?.history.push("/manual-time");
  //   }
  // }, [role]);
  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && from === "web") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _useQuery = useQuery(PERSONAL_STAT_DATA_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId,
        url: url || (user === null || user === void 0 ? void 0 : user.uniqueUrl),
        startDate: !props.from ? Number(moment(startDate).format("x")) : Number(moment().subtract(7, "d").format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        from: !props.from ? "web" : "desktop",
        projectSetting: organisationSettings.projectManagementFeature ? true : false,
        manualTimeSetting: organisationSettings.manualTimeFeature ? true : false,
        role: role,
        timezoneFilter: timezoneFilter,
        dateRange: dateFilter
      },
      skip: !organisationId || !teamId
    }),
    personalData = _useQuery.data,
    personalError = _useQuery.error,
    personalLoading = _useQuery.loading,
    personalDataRefresh = _useQuery.refetch;
  if (!props.from) {
    React.useEffect(function () {
      personalDataRefresh === null || personalDataRefresh === void 0 ? void 0 : personalDataRefresh();
    }, [props.location.key]);
  }
  if (props.from) {
    React.useEffect(function () {
      personalDataRefresh === null || personalDataRefresh === void 0 ? void 0 : personalDataRefresh();
    }, [task]);
  }
  if (personalLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (personalError) {
    if (personalError.networkError) {
      // Handle network errors
      return /*#__PURE__*/React.createElement("div", {
        className: "common-err-refresh-text"
      }, "Something went wrong, please refresh the page.");
    }
    if (personalError.graphQLErrors) {
      var errorMessage = "";
      personalError.graphQLErrors.forEach(function (_ref2) {
        var message = _ref2.message;
        if (message === "Unauthorized Access") {
          // Handle unauthorized access error
          // You can redirect to a login page or display a message to the user
          errorMessage = /*#__PURE__*/React.createElement("div", {
            className: "common-err-refresh-text-access"
          }, "Unauthorized Access. ");
        } else {
          errorMessage = /*#__PURE__*/React.createElement("div", {
            className: "common-err-refresh-text"
          }, "Something went wrong, please refresh the page.");
        }
      });
      return errorMessage;
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "common-err-refresh-text"
      }, "Something went wrong, please refresh the page.");
    }
  }
  if (!personalData) {
    return null;
  }

  // for random color generation
  var chartColor = {};
  var chartListColor = [];
  var colorTemp = 0;
  for (var i = 0; i <= (personalData === null || personalData === void 0 ? void 0 : (_personalData$persona = personalData.personalStatsMetrics) === null || _personalData$persona === void 0 ? void 0 : _personalData$persona.apps.length); i++) {
    var _personalData$persona;
    //let hexValue = randomColorWithBrightness(50);
    //const rgbValue = hexToRgb(hexValue);
    colorTemp = i;
    if (lightAndDarkColors.length <= Number(i)) {
      colorTemp = 0;
    }
    var rgbValue = hexToRgb(lightAndDarkColors[colorTemp].color);
    var t = rgbValue.join();
    var t1 = t.replace(/,/g, " ");
    var str = "rgb(" + t1 + " / 30%)";
    chartColor[i] = {
      color: lightAndDarkColors[colorTemp].color
    };
    chartListColor.push({
      color: lightAndDarkColors[colorTemp].color,
      backgroundColor: str,
      fontColor: lightAndDarkColors[colorTemp].fontColor
    });
  }

  // for project random color generation
  var projectChartColor = {};
  var projectChartListColor = [];
  var projectColorTemp = 0;
  for (var _i = 0; _i <= (personalData === null || personalData === void 0 ? void 0 : (_personalData$persona2 = personalData.personalStatsMetrics) === null || _personalData$persona2 === void 0 ? void 0 : (_personalData$persona3 = _personalData$persona2.projectDashboardDetails) === null || _personalData$persona3 === void 0 ? void 0 : _personalData$persona3.length); _i++) {
    var _personalData$persona2, _personalData$persona3;
    projectColorTemp = _i;
    if (lightAndDarkColors.length <= Number(_i)) {
      projectColorTemp = 0;
    }
    var _rgbValue = hexToRgb(lightAndDarkColors[projectColorTemp].color);
    var _t = _rgbValue.join();
    var _t2 = _t.replace(/,/g, " ");
    var _str = "rgb(" + _t2 + " / 30%)";
    projectChartColor[_i] = {
      color: lightAndDarkColors[projectColorTemp].color
    };
    projectChartListColor.push({
      color: lightAndDarkColors[projectColorTemp].color,
      backgroundColor: _str,
      fontColor: lightAndDarkColors[projectColorTemp].fontColor
    });
  }

  // for manual time random color generation
  var manualTimeChartColor = {};
  var manualTimeChartListColor = [];
  var manualTimeColorTemp = 0;
  for (var _i2 = 0; _i2 <= (personalData === null || personalData === void 0 ? void 0 : (_personalData$persona4 = personalData.personalStatsMetrics) === null || _personalData$persona4 === void 0 ? void 0 : (_personalData$persona5 = _personalData$persona4.manualDashboardDetails) === null || _personalData$persona5 === void 0 ? void 0 : _personalData$persona5.length); _i2++) {
    var _personalData$persona4, _personalData$persona5;
    manualTimeColorTemp = _i2;
    if (lightAndDarkColors.length <= Number(_i2)) {
      manualTimeColorTemp = 0;
    }
    var _rgbValue2 = hexToRgb(lightAndDarkColors[manualTimeColorTemp].color);
    var _t3 = _rgbValue2.join();
    var _t4 = _t3.replace(/,/g, " ");
    var _str2 = "rgb(" + _t4 + " / 30%)";
    manualTimeChartColor[_i2] = {
      color: lightAndDarkColors[manualTimeColorTemp].color
    };
    manualTimeChartListColor.push({
      color: lightAndDarkColors[manualTimeColorTemp].color,
      backgroundColor: _str2,
      fontColor: lightAndDarkColors[manualTimeColorTemp].fontColor
    });
  }
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var currentSystemDate = moment().tz(currentTimezone).format("MMMM DD");
  var orgTimezoneDate = moment().tz(organisationSettings.organisationTimezone).format("MMMM DD");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio | Personal Statistics | ".concat(user === null || user === void 0 ? void 0 : user.displayName))), /*#__PURE__*/React.createElement("div", {
    className: !props.from ? "personal-statistics-root" : "desktop-personal-statistics-root"
  }, role != "Member" ? /*#__PURE__*/React.createElement(BillingDueExtendedMsg, {
    failedPlanEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.failedPlanEnd,
    billingPeriodEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.billingPeriodEnd,
    handleCheckout: null,
    pageName: "dashboard",
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    history: props === null || props === void 0 ? void 0 : props.history
  }) : null, role != "Member" ? /*#__PURE__*/React.createElement(BillingBankTrasferPlanEndBeforeMsg, {
    beforePlanEndAlert: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.beforePlanEndAlert,
    planEnd: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planEnd,
    planStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus,
    paymentType: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.paymentType
  }) : null, dateFilter == "Today" && currentSystemDate != orgTimezoneDate ? /*#__PURE__*/React.createElement(WarningCardOrgTimezone, {
    currentSystemDate: currentSystemDate,
    orgTimezoneDate: orgTimezoneDate,
    currentSystemTimezone: currentTimezone,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
  }) : null, /*#__PURE__*/React.createElement(NewProductCard, {
    planName: organisationBilling.planName,
    isTrial: organisationBilling.isTrial
  }), !props.from ? /*#__PURE__*/React.createElement(PersonalHeaderCards, {
    metrics: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona6 = personalData.personalStatsMetrics) === null || _personalData$persona6 === void 0 ? void 0 : _personalData$persona6.metrics,
    user: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona7 = personalData.personalStatsMetrics) === null || _personalData$persona7 === void 0 ? void 0 : _personalData$persona7.user,
    currentlyUsingAppAndProject: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona8 = personalData.personalStatsMetrics) === null || _personalData$persona8 === void 0 ? void 0 : _personalData$persona8.currentlyUsingAppAndProject,
    startDate: startDate,
    endDate: endDate,
    pageComponent: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona9 = personalData.personalStatsMetrics) === null || _personalData$persona9 === void 0 ? void 0 : _personalData$persona9.pageComponent,
    organisationSettings: organisationSettings,
    userInviteStatus: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona10 = personalData.personalStatsMetrics) === null || _personalData$persona10 === void 0 ? void 0 : _personalData$persona10.userInviteStatus,
    profileDetails: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona11 = personalData.personalStatsMetrics) === null || _personalData$persona11 === void 0 ? void 0 : _personalData$persona11.profileDetails
  }) : null, from == "web" && organisationSettings.manualTimeFeature == true ? /*#__PURE__*/React.createElement(ManualTimeSummary, {
    chartColor: manualTimeChartColor,
    taskData: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona12 = personalData.personalStatsMetrics) === null || _personalData$persona12 === void 0 ? void 0 : _personalData$persona12.manualDashboardDetails,
    from: props === null || props === void 0 ? void 0 : props.from
  }) : null, /*#__PURE__*/React.createElement(ActivitiesChart, {
    workTimeSummary: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona13 = personalData.personalStatsMetrics) === null || _personalData$persona13 === void 0 ? void 0 : _personalData$persona13.workTimeSummary,
    from: props.from,
    organisationTimezone: organisationSettings.organisationTimezone
  }), organisationSettings.trackAppsAndWebsites && (role == "Admin" || role == "Head") ? /*#__PURE__*/React.createElement(TopAppsAndWebsiteChart, {
    chartColor: chartColor,
    chartListColor: chartListColor,
    teamTopAppsAndWebsite: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona14 = personalData.personalStatsMetrics) === null || _personalData$persona14 === void 0 ? void 0 : _personalData$persona14.apps,
    from: props.from,
    startDate: startDate,
    endDate: endDate,
    Link: Link,
    linkProps: linkProps
  }) : null, !props.from && role != "Member" ? /*#__PURE__*/React.createElement(ClockInClockOutTime, {
    clockInClockOut: personalData === null || personalData === void 0 ? void 0 : (_personalData$persona15 = personalData.personalStatsMetrics) === null || _personalData$persona15 === void 0 ? void 0 : _personalData$persona15.clockInClockOut,
    startDate: startDate,
    endDate: endDate,
    Link: Link,
    linkProps: linkProps
  }) : null));
};
var ColumnNameList = ["Date", "Start Time", "End Time", "Activity Duration"];
var TaskColumnNameList = ["Task title", "Hours worked", "Date", "Started at", "Stopped at"];
var TaskSection = function TaskSection(props) {
  var workTaskSummary = props.workTaskSummary;
  //console.log(workTaskSummary);
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-footer"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-work-task-footer-section personal-statistic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-Task-head-website-list"
  }, "Worked Task Summary"), workTaskSummary !== null ? /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    hover: true,
    className: "personal-clockin-clockout-content-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "personal-clockin-clockout-content-data-header"
  }, /*#__PURE__*/React.createElement("tr", null, TaskColumnNameList.map(function (columnName) {
    return /*#__PURE__*/React.createElement("th", {
      key: columnName
    }, columnName);
  }))), /*#__PURE__*/React.createElement("tbody", {
    className: "Teams-root-table-body"
  }, workTaskSummary.map(function (data) {
    var _data$project, _data$task;
    return /*#__PURE__*/React.createElement("tr", {
      key: "",
      className: "personal-clockin-clockout-content-data-details"
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "personal-Task-root-content-data-details-name-data"
    }, /*#__PURE__*/React.createElement("p", {
      className: "personal-Task-root-project-name"
    }, data === null || data === void 0 ? void 0 : (_data$project = data.project) === null || _data$project === void 0 ? void 0 : _data$project.projectName), /*#__PURE__*/React.createElement("p", {
      className: "personal-Task-root-task-name"
    }, data === null || data === void 0 ? void 0 : (_data$task = data.task) === null || _data$task === void 0 ? void 0 : _data$task.taskName))), /*#__PURE__*/React.createElement("td", null, data.totalHours !== null ? convertSecToHoursAndMinutesAndSecWithTextShortForm(Number(data.totalHours)) : "0h:0m"), /*#__PURE__*/React.createElement("td", null, moment(data.startTime).format("DD MMMM YYYY")), /*#__PURE__*/React.createElement("td", null, data.startTime !== null ? moment(data.startTime).format("hh:mm A") : "-"), /*#__PURE__*/React.createElement("td", null, data.stopTime !== null ? moment(data.stopTime).format("hh:mm A") : "Working On"));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "personal-no-data-text"
  }, "No data found"))));
};
var ClockInClockOutTime = function ClockInClockOutTime(props) {
  var clockInClockOut = props.clockInClockOut,
    startDate = props.startDate,
    endDate = props.endDate,
    Link = props.Link,
    linkProps = props.linkProps;
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-footer"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-task-section personal-statistic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-section-date"
  }, "Clock In & Out Summary"), /*#__PURE__*/React.createElement(React.Fragment, null, moment(startDate).isSame(moment(endDate !== null && endDate !== void 0 ? endDate : startDate), "day") ? clockInClockOut !== null ? /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    className: "personal-clockin-clockout-content-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "personal-clockin-clockout-content-data-header"
  }, /*#__PURE__*/React.createElement("tr", null, ColumnNameList.map(function (columnName) {
    return /*#__PURE__*/React.createElement("th", {
      key: columnName
    }, columnName);
  }))), /*#__PURE__*/React.createElement("tbody", null, clockInClockOut.map(function (data) {
    var reason = data.activityReason === "socket_disconnect" ? "Internet interrupted" : data.activityReason === "socket_timeout" ? "Internet interrupted" : data.activityReason === "clock_out" ? "Clocked out from work" : data.activityReason === "took_break" ? "Took a break from work" : data.activityReason === "app_quit" ? "Clocked out and closed the workfolio app" : data.activityReason === "system_locked" ? "System locked and clocked out from work" : data.activityReason === "before_update" ? "Updating the workfolio app" : data.activityReason === "system_suspend" ? "System suspended due to inactivity" : data.activityReason === "sign_out" ? "User signed out" : data.activityReason === "system_offline" ? "Internet disconnected from the system" : data.activityReason === "idle_time_exceeded" ? "The user is inactive, so work stopped automatically" : data.activityReason;
    return /*#__PURE__*/React.createElement("tr", {
      key: data.workedSec
      //className="personal-clockin-clockout-content-data-details"
      ,
      className: classNames("personal-clockin-clockout-content-data-details", {
        "personal-clockin-clockout-content-data-details-selected": data.activityReason === null
      })
    }, /*#__PURE__*/React.createElement("td", null, moment(Number(data.activityStart)).format("DD MMMM YYYY")), /*#__PURE__*/React.createElement("td", null, data.activityStart !== null ? moment(Number(data.activityStart)).format("hh:mm A") : "-"), /*#__PURE__*/React.createElement("td", null, data.activityEnd !== null ? moment(Number(data.activityEnd)).format("hh:mm A") : data.activity === "start" ? "Working On" : "-"), /*#__PURE__*/React.createElement("td", null, data.activityEnd !== null ? data.activityReason !== null ? reason : /*#__PURE__*/React.createElement(React.Fragment, null, "Worked ", /*#__PURE__*/React.createElement("span", {
      className: "personal-clockin-clockout-content-data-details-for"
    }, "for"), /*#__PURE__*/React.createElement("span", {
      className: "personal-clockin-clockout-content-data-details-worked-hours"
    }, data.workedSec !== null ? convertSecToHoursAndMinutesAndSecWithTextShortForm(Number(data.totalHours)) : "0h:0m")) : data.activity === "start" ? "-" : reason));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "personal-no-data-text"
  }, "No data found") : /*#__PURE__*/React.createElement("div", {
    className: "personal-report-activity-log-link"
  }, "Visit", " ", /*#__PURE__*/React.createElement(Link, _defineProperty({}, linkProps, "/reports/work-activity-log"), /*#__PURE__*/React.createElement("span", {
    className: "timelapse-card-see-more-button"
  }, " this report")), " ", "to see your team members' clock-in and clock-out summary")))));
};
var PersonalHeaderCards = function PersonalHeaderCards(props) {
  var metrics = props.metrics,
    user = props.user,
    currentlyUsingAppAndProject = props.currentlyUsingAppAndProject,
    startDate = props.startDate,
    endDate = props.endDate,
    pageComponent = props.pageComponent,
    organisationSettings = props.organisationSettings,
    userInviteStatus = props.userInviteStatus,
    profileDetails = props.profileDetails;
  var isSameDayValue = startDate && endDate ? moment(startDate).isSame(moment(endDate), "day") : true;
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-header"
  }, /*#__PURE__*/React.createElement("div", {
    //className="personal-header-profile"
    className: classNames("personal-header-profile", {
      "personal-header-profile-multiple-date": endDate !== null
    })
  }, user.profileUrl === null || user.profileUrl === "" ? /*#__PURE__*/React.createElement("div", {
    className: "personal-header-avatar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-profile-avatar"
  }, user.displayName.charAt(0).toUpperCase())) : /*#__PURE__*/React.createElement("div", {
    className: "personal-card-avatar-profile"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: user.profileUrl,
    className: "personal-card-avatar-profile-img"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-name"
  }, user.displayName), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-email"
  }, user.emailId), user.employeeId ? /*#__PURE__*/React.createElement("div", {
    className: "personal-header-emp-id"
  }, "Emp ID: ", user.employeeId) : null)), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-text"
  }, "Total Worked Hours"), metrics.totalWorkTime >= 64800 && isSameDayValue && metrics.updatedBy == null ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "active-working",
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, /*#__PURE__*/React.createElement("div", null, "Error in hours, pls contact Workfolio support or mail to team@getworkfolio.com "))
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-time-error"
  }, "Error in Hours,Contact Workfolio Team")) : /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, metrics.totalWorkSec), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-help-text"
  }, "Clocked-in hours (excludes breaks & screen lock)")), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-text"
  }, "Active Time", /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "active-working",
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, /*#__PURE__*/React.createElement("div", null, "Active time excludes idle time from worked hours. "))
  }, /*#__PURE__*/React.createElement("span", {
    className: "personal-header-summary-card-text-ques"
  }, " ", /*#__PURE__*/React.createElement(HiQuestionMarkCircle, null)))), metrics.totalWorkTime >= 86400 && isSameDayValue ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "active-working",
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, /*#__PURE__*/React.createElement("div", null, "Error in hours, pls contact Workfolio support or mail to team@getworkfolio.com "))
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-time-error"
  }, "Error in Hours,Contact Workfolio Team")) : /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, metrics.activeTime), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-help-text"
  }, "Time spent actively engaging with the system")), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-text"
  }, "Productive Apps %", /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "currently-working",
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, /*#__PURE__*/React.createElement("div", null, "Review apps to increase the productive apps %"))
  }, /*#__PURE__*/React.createElement("span", {
    className: "personal-header-summary-card-text-ques"
  }, " ", /*#__PURE__*/React.createElement(HiQuestionMarkCircle, null)))), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, metrics.avgProductivityPercentage, "%"), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-help-text"
  }, "Of time spent in apps marked as productive by the Admin")), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-text"
  }, "Idle Time Spent %"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, metrics.avgIdelSec, "%"), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-help-text"
  }, "No system activity (inactive period)")), endDate === null ? /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-text"
  }, "Clock-in Time"), /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, endDate === null || isSameDay(startDate, endDate) ? /*#__PURE__*/React.createElement(React.Fragment, null, metrics.clockIn === "" ? "-" : moment(Number(metrics.clockIn)).format("hh:mm A")) : "-"), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-help-text"
  }, "Start time recorded for the selected day")) : null, endDate === null ? /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-text"
  }, "Clock-Out Time"), endDate === null || isSameDay(startDate, endDate) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, metrics.clockOut === "" || metrics.clockOut === "-" || metrics.currentStatus !== null && metrics.currentStatus !== "break" && metrics.currentStatus !== "stop" && endDate === null ? "-" : moment(Number(metrics.clockOut)).format("hh:mm A")), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-help-text"
  }, "End time recorded for the selected day")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
    className: "mb-0 mt-1 font-weight-bold text-dark"
  }, "-"), /*#__PURE__*/React.createElement("div", {
    className: "personal-header-summary-card-help-text"
  }, "Pending"))) : null);
};
var ActivitiesChart = function ActivitiesChart(props) {
  var workTimeSummary = props.workTimeSummary,
    from = props.from,
    organisationTimezone = props.organisationTimezone;
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-content"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-section personal-statistic"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "head-activities-data-list"
  }, from ? "Last 7 days work hours summary" : "Activities")), /*#__PURE__*/React.createElement(ProjectDetailsChart, {
    workTimeSummary: workTimeSummary,
    organisationTimezone: organisationTimezone
  }))));
};
var ProjectSummary = function ProjectSummary(props) {
  var chartColor = props.chartColor,
    taskData = props.taskData,
    from = props.from;
  var taskChartDetails = taskData.reduce(function (acc, curr) {
    var taskName = curr.taskName,
      totalTimeInSec = curr.totalTimeInSec,
      totalTimeInHours = curr.totalTimeInHours;
    return [].concat(_toConsumableArray(acc), [[taskName, totalTimeInSec, "<div class=\"apps-tootlip\">\n            <span class=\"apps-tootlip-title\">".concat(taskName, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-time\">Time: ").concat(totalTimeInHours, "</span>\n          </div>")]]);
  }, [["Task Name", "Total Time", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]);
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-content",
    style: {
      marginTop: from ? "1rem" : null
    }
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-project-and-task-section-top personal-project-and-task-section",
    style: {
      height: from ? "inherit" : null
    }
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-worked-header-name"
  }, "Task Dashboard")), /*#__PURE__*/React.createElement(Row, {
    className: "project-task-section-list-content"
  }, " ", /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 8,
    className: "personal-footer-section-top-scroll"
  }, taskData.length !== 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-root"
  }, taskData.map(function (tasks, index) {
    // console.log("tasks", tasks);
    // console.log("tasks", chartColor[index].color);

    return /*#__PURE__*/React.createElement("div", {
      className: "project-task-list",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-name-bullet-list",
      style: {
        background: chartColor[index].color
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "project-task-details-data"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "project-task-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-project-task-name",
      title: tasks.taskName
    }, tasks.taskName), /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-project-details-project-name"
    }, " ", tasks.projectName)), /*#__PURE__*/React.createElement("span", {
      className: "project-task-worked-time"
    }, tasks.totalTimeInHours)));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found")), /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 4
  }, taskData.length !== 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "website-chart-project-task"
  }, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "250px",
    bottom: "0px",
    left: "0px",
    right: "0px",
    position: "absolute",
    chartType: "PieChart",
    loader: /*#__PURE__*/React.createElement("div", null, "Loading Chart"),
    data: taskChartDetails,
    options: {
      legend: "none",
      pieSliceText: "none",
      chartArea: {
        width: "95%",
        height: "90%",
        bottom: "0px",
        left: "0px",
        right: "0px"
      },
      //  backgroundColor: "#fcfcfc",
      slices: chartColor,
      // Just add this option
      pieHole: 0.4,
      tooltip: {
        isHtml: true,
        trigger: "visible"
      }
    }
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found"))))));
};
var ManualTimeSummary = function ManualTimeSummary(props) {
  var chartColor = props.chartColor,
    taskData = props.taskData,
    from = props.from;

  // style={{ marginTop: from ? "1rem" : null }}
  // style={{ height: from ? "inherit" : null }}
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-content",
    style: {
      marginTop: from ? "1rem" : null
    }
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-project-and-task-section-top personal-project-and-task-section",
    style: {
      height: from ? "inherit" : null
    }
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-worked-header-name"
  }, "Manual Time Summary")), /*#__PURE__*/React.createElement(Row, null, " ", /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 12,
    className: "personal-footer-section-top-scroll"
  }, taskData.length !== 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-root"
  }, taskData.map(function (tasks, index) {
    // console.log("tasks", tasks);
    // console.log("tasks", chartColor[index].color);

    return /*#__PURE__*/React.createElement("div", {
      className: "project-task-list",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-task-name-bullet-list",
      style: {
        background: chartColor[index].color
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "project-task-details-data"
    }, " ", /*#__PURE__*/React.createElement("div", {
      className: "project-task-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-project-task-name",
      title: tasks.taskName
    }, tasks.taskName), /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-project-details-project-name"
    }, " ", tasks.projectName)), /*#__PURE__*/React.createElement("span", {
      className: "project-task-worked-time"
    }, tasks.totalTimeInHours)));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found"))))));
};
var TopAppsAndWebsiteChart = function TopAppsAndWebsiteChart(props) {
  var teamTopAppsAndWebsite = props.teamTopAppsAndWebsite,
    chartListColor = props.chartListColor,
    chartColor = props.chartColor,
    from = props.from,
    startDate = props.startDate,
    endDate = props.endDate,
    Link = props.Link,
    linkProps = props.linkProps;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusedRow = _React$useState2[0],
    setFocusedRow = _React$useState2[1];

  // let appsAndWebsitesData = from
  //   ? teamTopAppsAndWebsite.filter((object) => moment(object.visitedDay).isSame(moment(), "day"))
  //   : teamTopAppsAndWebsite;

  var teamTopAppsAndWebsiteChart = teamTopAppsAndWebsite.reduce(function (acc, curr) {
    var title = curr.title,
      timeInSecs = curr.timeInSecs;
    var timeInHrs = convertSecToHoursAndMinutesAndSecWithTextShortForm(Number(timeInSecs));
    return [].concat(_toConsumableArray(acc), [[title, timeInSecs, "<div class=\"apps-tootlip\">\n          <span class=\"apps-tootlip-title\">".concat(title, "</span>\n          <br>\n          <span class=\"apps-tootlip apps-tootlip-time\">Time: ").concat(timeInHrs, "</span>\n        </div>")]]);
  }, [["Website", "Hours per Day", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]);
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-content"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-section-top personal-statistic"
  }, /*#__PURE__*/React.createElement(Row, null, moment(startDate).isSame(moment(endDate !== null && endDate !== void 0 ? endDate : startDate), "day") ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 6,
    className: "personal-footer-section-top-scroll"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "head-website-list personal-staticstic-size"
  }, from ? "Today's used Apps" : "Used Apps and Websites")), teamTopAppsAndWebsite.length !== 0 && teamTopAppsAndWebsiteChart.length > 1 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-website-list"
  }, teamTopAppsAndWebsite.map(function (topApp, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "website-list",
      style: focusedRow === index ? {
        border: "1px solid ".concat(chartSelectedColor.color),
        backgroundColor: chartSelectedColor.backgroundColor
      } : {
        border: "1px solid ".concat(chartListColor[index].color),
        backgroundColor: chartListColor[index].backgroundColor
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: topApp.icon,
      alt: "Logo",
      className: "website-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "website-name",
      title: topApp.title
    }, topApp.title), /*#__PURE__*/React.createElement("span", {
      className: "website-type",
      style: focusedRow === index ? {
        color: chartSelectedColor.fontColor
      } : {
        color: chartListColor[index].fontColor
      }
    }, topApp.productivityStatus));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found")), /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 6
  }, moment(startDate).isSame(moment(endDate !== null && endDate !== void 0 ? endDate : startDate), "day") ? teamTopAppsAndWebsite.length !== 0 ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "website-chart-personal"
  }, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "250px",
    bottom: "0px",
    left: "0px",
    right: "0px",
    position: "absolute",
    chartType: "PieChart",
    loader: /*#__PURE__*/React.createElement("div", null, "Loading Chart"),
    data: teamTopAppsAndWebsiteChart,
    options: {
      legend: "none",
      pieSliceText: "none",
      chartArea: {
        width: "95%",
        height: "90%",
        bottom: "0px",
        left: "0px",
        right: "0px"
      },
      backgroundColor: "#fcfcfc",
      slices: chartColor,
      // Just add this option
      pieHole: 0.4,
      tooltip: {
        isHtml: true,
        trigger: "visible"
      }
    },
    chartEvents: [{
      eventName: "ready",
      callback: function callback(_ref4) {
        var chartWrapper = _ref4.chartWrapper,
          google = _ref4.google;
        //setLoaded(true);
        var chart = chartWrapper.getChart();
        google.visualization.events.addListener(chart, "onmouseover", function (e) {
          var row = e.row;
          setFocusedRow(row);
        });
        google.visualization.events.addListener(chart, "onmouseout", function () {
          if (focusedRow) {
            setFocusedRow(null);
          }
        });
      }
    }]
    // rootProps={{ "data-testid": "3" }}
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found") : null)) : /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 12,
    className: "personal-footer-section-top-scroll"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "head-website-list personal-staticstic-size"
  }, from ? "Today's used Apps" : "Used Apps and Websites")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "personal-report-activity-log-link"
  }, "Visit", " ", /*#__PURE__*/React.createElement(Link, _defineProperty({}, linkProps, "/reports/apps-usage"), /*#__PURE__*/React.createElement("span", {
    className: "timelapse-card-see-more-button"
  }, " this report")), " ", "to see your team members' used apps and websites data")))))));
};
var ProjectDetailsChart = function ProjectDetailsChart(props) {
  var workTimeSummary = props.workTimeSummary,
    organisationTimezone = props.organisationTimezone;
  var workTimeSummaryGroup = [];
  if (workTimeSummary) {
    workTimeSummaryGroup = workTimeSummary.reduce(function (acc, curr) {
      var productiveSec = curr.productiveSec,
        unproductiveSec = curr.unproductiveSec,
        neutralSec = curr.neutralSec,
        untrackedSec = curr.untrackedSec,
        workedDay = curr.workedDay;
      var projectPosition = acc.findIndex(function (p) {
        return moment(p.workedDay).format("MMM DD YYYY") === moment(workedDay).format("MMM DD YYYY");
      });
      //console.log(projectPosition);
      if (projectPosition >= 0) {
        acc[projectPosition] = _objectSpread(_objectSpread({}, acc[projectPosition]), {}, {
          productiveSec: acc[projectPosition].productiveSec + Number(productiveSec),
          unproductiveSec: acc[projectPosition].unproductiveSec + Number(unproductiveSec),
          neutralSec: acc[projectPosition].neutralSec + Number(neutralSec),
          untrackedSec: acc[projectPosition].untrackedSec + Number(untrackedSec)
        });
      } else {
        acc.push({
          productiveSec: productiveSec,
          unproductiveSec: unproductiveSec,
          neutralSec: neutralSec,
          untrackedSec: untrackedSec,
          workedDay: workedDay
        });
      }
      return acc;
    }, []);
  }

  // console.log("workTimeSummaryGroup");
  // console.log(workTimeSummaryGroup);

  var workTimeSummaryChart = workTimeSummaryGroup.reduce(function (acc, curr) {
    var workedDay = curr.workedDay,
      productiveSec = curr.productiveSec,
      unproductiveSec = curr.unproductiveSec,
      neutralSec = curr.neutralSec,
      untrackedSec = curr.untrackedSec;
    // console.log(productiveSec, unproductiveSec, neutralSec);
    var productiveTimeInHrs = convertSecToHoursAndMinutesWithTextShortForm(Number(productiveSec));
    var unproductiveTimeInHrs = convertSecToHoursAndMinutesWithTextShortForm(Number(unproductiveSec));
    var neutralTimeInHrs = convertSecToHoursAndMinutesWithTextShortForm(Number(neutralSec));
    var untrackedTimeInHrs = convertSecToHoursAndMinutesWithTextShortForm(Number(untrackedSec));
    return [].concat(_toConsumableArray(acc), [[moment(workedDay).tz(organisationTimezone).format("MMM DD"), convertSecToHours(productiveSec), "<div class=\"apps-tootlip\">\n        <span class=\"apps-tootlip-title\">Productive</span>\n        <br>\n        <span class=\"apps-tootlip apps-tootlip-time\">Time: ".concat(productiveTimeInHrs, "</span>\n      </div>"), convertSecToHours(neutralSec), "<div class=\"apps-tootlip\">\n        <span class=\"apps-tootlip-title\">Neutral</span>\n        <br>\n        <span class=\"apps-tootlip apps-tootlip-time\">Time: ".concat(neutralTimeInHrs, "</span>\n      </div>"), convertSecToHours(unproductiveSec), "<div class=\"apps-tootlip\">\n        <span class=\"apps-tootlip-title\">Unproductive</span>\n        <br>\n        <span class=\"apps-tootlip apps-tootlip-time\">Time: ".concat(unproductiveTimeInHrs, "</span>\n      </div>"), convertSecToHours(untrackedSec), "<div class=\"apps-tootlip\">\n    <span class=\"apps-tootlip-title\">Untracked</span>\n    <br>\n    <span class=\"apps-tootlip apps-tootlip-time\">Time: ".concat(untrackedTimeInHrs, "</span>\n  </div>")]]);
  }, [["Date", "productive", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "neutral", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "unproductive", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "untracked", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]);
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-details-chart"
  }, workTimeSummaryChart.length > 1 ? /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "230px",
    left: "10px",
    right: "10px"
    // left:10,right:10,top:20,bottom:20
    ,
    chartType: "ColumnChart",
    loader: /*#__PURE__*/React.createElement("div", {
      className: "project-details-chart-loader"
    }, "Loading Chart"),
    data: workTimeSummaryChart,
    options: {
      title: "",
      chartArea: {
        width: "85%"
      },
      isStacked: true,
      vAxis: {
        minValue: 0,
        // title: 'Worked Time (In Hours)',
        // titleTextStyle: {
        //   italic:false,
        // }
        format: "# hours"
        //baselineColor: "red",
        //direction: -1,
        // slantedText: true,
        // slantedTextAngle: 90,
      },
      hAxis: {
        baselineColor: "red"
      },
      backgroundColor: "#fcfcfc",
      legend: "none",
      padding: {
        right: 10,
        bottom: 20,
        left: 20
      },
      colors: ["#59BAAA", "#787877", "#EF9493", "#cdc2ae"],
      tooltip: {
        isHtml: true,
        trigger: "visible"
      }
    }
    // For tests
    ,
    rootProps: {
      "data-testid": "3"
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found"));
};
var ProjectProgressChart = function ProjectProgressChart(props) {
  var projectTotalHours = props.projectTotalHours;
  //console.log(projectTotalHours);
  var sum = 0;
  var projectProgressArray = [];
  var projectProgressSum = projectTotalHours.map(function (item) {
    var projectName = item.projectName,
      workedSec = item.workedSec;
    sum = Number(sum) + Number(workedSec);
    return sum;
  });
  projectTotalHours.map(function (item) {
    var project = item.project,
      workedSec = item.workedSec;
    var percentage = sum !== 0 ? workedSec / Number(sum) * 100 : 0;
    return projectProgressArray.push({
      projectName: project.projectName,
      totalHoursPercent: percentage
    });
  });
  var array = ["success", "warning", "danger", "primary", "info", "secondary", "dark"];
  //  console.log(projectProgressSum);
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-footer"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-section-progress-bar personal-statistic"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    lg: 12
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-head-website-list"
  }, "Worked Hours on Projects")), projectProgressArray.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "project-progress"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    now: sum
  }, projectProgressArray.map(function (data, index) {
    return /*#__PURE__*/React.createElement(ProgressBar, {
      variant: array[index],
      now: data.totalHoursPercent,
      key: index
    });
  })))), /*#__PURE__*/React.createElement(Row, {
    className: "project-name-row"
  }, projectProgressArray.map(function (data, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "project-name-list",
      key: data.projectName
    }, /*#__PURE__*/React.createElement("span", {
      className: "project-color project-color-".concat(array[index])
    }), /*#__PURE__*/React.createElement("span", {
      className: "project-name"
    }, data.projectName), /*#__PURE__*/React.createElement("span", {
      className: "project-percentage"
    }, Math.round(data.totalHoursPercent), "%"));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "overview-no-data-text"
  }, "No data found"))))));
};
var data = [{
  description: "Working on db config changes ",
  projectName: "chrome app",
  taskName: "db scaling",
  startedAt: "2:00 pm",
  endedAt: "",
  duration: "2h",
  addedAt: "1628852780561"
}, {
  description: "Working on integration ",
  projectName: "development",
  taskName: "code",
  startedAt: "11:00 am",
  endedAt: "1:30 pm",
  duration: "2h 30m",
  addedAt: "1628852780561"
}, {
  description: "Meeting with clients",
  projectName: "chrome app",
  taskName: "db scaling",
  startedAt: "10:00 am",
  endedAt: "11:00 am",
  duration: "1h",
  addedAt: "1628852780561"
}];
var ManualData = [{
  description: "Working on project ui design  ",
  totalHours: "2 hours",
  status: "approved",
  addedAt: "1628852780561",
  by: "ragupathi"
}, {
  description: "Working on integration ",
  totalHours: "3 hours",
  status: "pending",
  addedAt: "1628852780561",
  by: ""
}, {
  description: "Working on db connection  ",
  totalHours: "1 hours",
  status: "approved",
  addedAt: "1628852780561",
  by: "ragupathi"
}, {
  description: "Working on project testing design  ",
  totalHours: "5 hours",
  status: "approved",
  addedAt: "1628852780561",
  by: "nandhini"
}];
var UserTaskDetails = function UserTaskDetails(props) {
  var _personalTaskData$per, _personalTaskData$per2;
  var personalTaskData = props.personalTaskData,
    personalTaskError = props.personalTaskError,
    personalTaskLoading = props.personalTaskLoading;
  if (personalTaskLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (personalTaskError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!personalTaskData) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-footer"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-task-section personal-statistic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-section-date"
  }, "Tasks"), personalTaskData !== null && personalTaskData !== void 0 && (_personalTaskData$per = personalTaskData.personalTaskDetail) !== null && _personalTaskData$per !== void 0 && _personalTaskData$per.projectTaskDetails.length ? /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "personal-statistics-task-card-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "personal-statistics-task-card-table-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Task description"), /*#__PURE__*/React.createElement("th", null, "Start Time"), /*#__PURE__*/React.createElement("th", null, "End Time"), /*#__PURE__*/React.createElement("th", null, "Duration"), /*#__PURE__*/React.createElement("th", null, "Date"))), /*#__PURE__*/React.createElement("tbody", {
    className: "personal-statistics-task-card-table-body"
  }, personalTaskData === null || personalTaskData === void 0 ? void 0 : (_personalTaskData$per2 = personalTaskData.personalTaskDetail) === null || _personalTaskData$per2 === void 0 ? void 0 : _personalTaskData$per2.projectTaskDetails.map(function (list, index) {
    var taskDescription = list.taskDescription,
      projectName = list.projectName,
      taskName = list.taskName,
      startTime = list.startTime,
      endTime = list.endTime,
      totalTimeInSec = list.totalTimeInSec,
      taskDate = list.taskDate;
    return /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "personal-statistics-task-card-table-data-details"
    }, /*#__PURE__*/React.createElement("td", {
      className: ""
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskDescription)
    }, /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-task-card-table-description"
    }, taskDescription)), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-poject",
        className: "project-tooltip-start"
      }, projectName, " - ", taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-task-card-table-name"
    }, projectName, " - ", taskName))), /*#__PURE__*/React.createElement("td", {
      className: ""
    }, startTime), /*#__PURE__*/React.createElement("td", {
      className: ""
    }, endTime === "" ? /*#__PURE__*/React.createElement("span", {
      className: "personal-statistics-task-card-table-ongoing"
    }, "ongoing") : endTime), /*#__PURE__*/React.createElement("td", {
      className: ""
    }, totalTimeInSec), /*#__PURE__*/React.createElement("td", null, moment.unix(taskDate / 1000).format("DD MMMM YYYY")));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "no-data-risk-setting"
  }, "You are yet to start the first task"))));
};
var UserOfflineTaskDetails = function UserOfflineTaskDetails(props) {
  var _personalTaskData$per3, _personalTaskData$per4;
  var personalTaskData = props.personalTaskData,
    personalTaskError = props.personalTaskError,
    personalTaskLoading = props.personalTaskLoading;
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-footer"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "personal-statistic-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-task-section personal-statistic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "personal-footer-section-date"
  }, "Offline Tasks"), personalTaskData !== null && personalTaskData !== void 0 && (_personalTaskData$per3 = personalTaskData.personalTaskDetail) !== null && _personalTaskData$per3 !== void 0 && _personalTaskData$per3.offlineTaskDetails.length ? /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "personal-statistics-task-card-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "personal-statistics-task-card-table-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Task description"), /*#__PURE__*/React.createElement("th", null, "Date"), /*#__PURE__*/React.createElement("th", null, "Duration"), /*#__PURE__*/React.createElement("th", null, "Review Status"))), /*#__PURE__*/React.createElement("tbody", {
    className: "personal-statistics-task-card-table-body"
  }, personalTaskData === null || personalTaskData === void 0 ? void 0 : (_personalTaskData$per4 = personalTaskData.personalTaskDetail) === null || _personalTaskData$per4 === void 0 ? void 0 : _personalTaskData$per4.offlineTaskDetails.map(function (list, index) {
    var taskDescription = list.taskDescription,
      projectName = list.projectName,
      startTime = list.startTime,
      endTime = list.endTime,
      totalHours = list.totalHours,
      taskDate = list.taskDate,
      reviewStatus = list.reviewStatus,
      reviewedName = list.reviewedName;
    return /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "personal-statistics-task-card-table-data-details"
    }, /*#__PURE__*/React.createElement("td", {
      className: ""
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskDescription)
    }, /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-task-card-table-description"
    }, taskDescription)), /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-poject",
        className: "project-tooltip-start"
      }, projectName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "personal-statistics-task-card-table-name"
    }, projectName))), /*#__PURE__*/React.createElement("td", null, moment.unix(taskDate / 1000).format("DD MMMM YYYY")), /*#__PURE__*/React.createElement("td", {
      className: ""
    }, totalHours), /*#__PURE__*/React.createElement("td", {
      className: ""
    }, reviewStatus == null ? "Pending" : reviewStatus == "approved" ? "Approved by ".concat(reviewedName) : reviewStatus));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "no-data-risk-setting"
  }, "You are yet to start the first task"))));
};
var PersonalStatisticsWrapper = function PersonalStatisticsWrapper(props) {
  var _React$useContext3 = React.useContext(FilterContext),
    role = _React$useContext3.role;
  if ((props === null || props === void 0 ? void 0 : props.from) === "desktop" || role == "Member") {
    return /*#__PURE__*/React.createElement(PersonalStatistics, _extends({
      from: props === null || props === void 0 ? void 0 : props.from,
      url: props.url
    }, props));
  } else {
    var _props$match;
    var _props$match$params = props === null || props === void 0 ? void 0 : (_props$match = props.match) === null || _props$match === void 0 ? void 0 : _props$match.params,
      url = _props$match$params.url;
    return /*#__PURE__*/React.createElement(UserSidemenu, {
      disableTeamView: true,
      history: props.history,
      match: props.match
    }, function (user) {
      return /*#__PURE__*/React.createElement(PersonalStatistics, _extends({
        user: user,
        url: url
      }, props));
    });
  }
};
export default PersonalStatisticsWrapper;